// extracted by mini-css-extract-plugin
module.exports = {"testimonial":"TestimonialsGroup_testimonial__rSAtX","TestimonialGroup":"TestimonialsGroup_TestimonialGroup__ZUrmY","testimonialGroup":"TestimonialsGroup_testimonialGroup__dkhyI"};